import React from 'react';
import { useSelector } from 'react-redux';
import { Breakpoint } from '@noths/polaris-client-ribbons-base';
import { Responsive } from '@noths/polaris-client-ribbons-design-system';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectTotalProducts } from 'src/redux/products/selectors/selectors';
import { ListingsControlsContainer } from '../ListingsControls/ListingsControlsContainer';
import * as styles from './ListingsControlsSideBar.styles';

export const ListingsControlsSideBar = () => {
  const state = useSelector((state: ReduxApplicationState) => state);
  const totalProducts = selectTotalProducts(state);

  return (
    <div css={styles.filterWrapper}>
      <Responsive minBreakpoint={Breakpoint.L}>
        <p css={styles.totalProducts}>Showing {totalProducts} products</p>
        <ListingsControlsContainer />
      </Responsive>
    </div>
  );
};
